import { PersonOutlineIcon } from '@applyboard/ui-icons';
import { Flex, Divider } from '@applyboard/crystal-ui';
import { useAppProcessing } from '~/pages/ApplicationDetails/context';

import { Card } from './Card';
import { LabelValue } from '~/components/uie-fix/LabelValue';
import { ChangeAgency } from './ChangeAgency';
import { ChangeStudent } from './ChangeStudent';

const formatStudentProfileLabel = (profile?: { givenName: string; familyName?: string; email: string }) => {
  if (!profile) return 'No account owner assigned';
  const names = [profile.givenName, profile.familyName].filter(Boolean).join(' ');
  return names ? names : profile.email;
};

export function ApplicationAssignment() {
  const { application } = useAppProcessing();

  return (
    <Card id="applicationAssignment" icon={PersonOutlineIcon} title="Account Details">
      <Flex direction="column" gap={6}>
        <Flex align="center" justify="between" gap={2}>
          <LabelValue label="Account Owner" value={formatStudentProfileLabel(application.studentProfile)} />
          <ChangeStudent />
        </Flex>
        <Divider m={0} />
        <Flex align="center" justify="between" gap={2}>
          <LabelValue label="Assigned Agency" value={application.agency?.agencyName ?? 'No agency assigned'} />
          <ChangeAgency />
        </Flex>
      </Flex>
    </Card>
  );
}
